import {Modal} from 'bootstrap';
import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-model-select-item',
  templateUrl: './model-select-item.component.html',
  styleUrls: ['./model-select-item.component.css'],
  standalone: false
})
export class ModelSelectItemComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;

  constructor() {
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
